export default {
	termsAndConditions: {
		lastUpdate: 'อัปเดตล่าสุด: 10 มิถุนายน 2024',
		content: `
		<p>ข้อกำหนดที่คุณจะพบด้านล่างมีความสำคัญเพราะว่า:</p>
		<ul>
			<li>พวกเขากำหนดสิทธิทางกฎหมายของคุณใน {siteName}.</li>
			<li>อธิบายสิทธิที่คุณมอบให้เราเมื่อคุณใช้ {siteName}.</li>
			<li>
				พวกเขาอธิบายกฎที่ทุกคนต้องเคารพเมื่อใช้ {siteName}.
			</li>
		</ul>
		<p>
			โปรดอ่านข้อกำหนดเหล่านี้อย่างละเอียด เช่นเดียวกับ {privacyPolicyLink} ของเราและเอกสารอื่น ๆ 
			ที่กล่าวถึงในข้อกำหนดเหล่านี้
		</p>
		<p>มาเริ่มกันเลย...</p>
		<h3>1. บทนำและข้อมูลของ {siteNameUpper}.</h3>
		<p>
			เว็บไซต์ {websiteLink} (ต่อไปนี้จะเรียกว่า "เว็บไซต์") เป็นของบริษัท
			{siteName} S.L (ต่อไปนี้จะเรียกว่า "{siteName}"), 
			บริษัทที่จัดตั้งขึ้นตามกฎหมายของสเปนที่มีที่อยู่ที่ Avenida de
			Cerdanyola, nº 75, 1º, Sant Cugat del Vallès (Barcelona), 
			ผู้ถือ CIF หมายเลข B-56.768.260 และจดทะเบียนในทะเบียนพาณิชย์ของบาร์เซโลนาในเล่ม
			49065, ฟอริโอ 0033, แผ่น B-606324, การลงทะเบียนครั้งแรก
		</p>
		<p>
			{siteName} นำเสนอเว็บไซต์นี้เพื่อให้คุณสามารถรู้จักเราได้ดียิ่งขึ้น,
			ทราบบริการที่เรามอบให้และถ้าคุณต้องการคุณสามารถติดต่อ
			และในกรณีที่เหมาะสม ทำสัญญากับเรา
		</p>
		<h3>2. วัตถุประสงค์และขอบเขตของการใช้ข้อกำหนด</h3>
		<p>
			เงื่อนไขการใช้งานเหล่านี้ประกอบด้วย {privacyPolicyLink} และ
			{cookiesPolicyLink}, เป็นกรอบกฎหมายที่ควบคุมการใช้เว็บไซต์
			{websiteLink} ข้อกำหนดการใช้งานเหล่านี้จะพร้อมใช้งานบนเว็บไซต์
			เป็นภาษาอังกฤษเพื่อให้คุณสามารถตรวจสอบ จัดเก็บหรือพิมพ์ได้ทุกเมื่อที่คุณต้องการ
		</p>
		<p>
			เพื่อทราบคำถามใด ๆ เกี่ยวกับการรักษาข้อมูลส่วนบุคคลของคุณโดย {siteName}.
			โปรดเยี่ยมชม {privacyPolicyLink} และ {cookiesPolicyLink} ของเรา
			ทั้งนโยบายจะพร้อมใช้งานในภาษาอังกฤษเพื่อให้คุณสามารถ
			ตรวจสอบ จัดเก็บหรือพิมพ์ได้ทุกเมื่อที่คุณต้องการ<br />
			{siteName} ใช้คุกกี้ของบุคคลที่สามบนเว็บไซต์ เพื่อหาข้อมูลเพิ่มเติม
			เกี่ยวกับประเภทของคุกกี้ที่ใช้ในเว็บ {websiteLink}, วัตถุประสงค์และวิธีการ
			กำหนดค่าเบราว์เซอร์ของคุณในกรณีที่คุณไม่ต้องการให้เราใช้คุกกี้เหล่านี้,
			โปรดเยี่ยมชม {cookiesPolicyLink} ของเรา
		</p>
		<p>
			ทั้งเงื่อนไขการใช้งานเหล่านี้ และ {privacyPolicyLink} และ
			{cookiesPolicyLink} ได้รับการจัดทำขึ้นตามบทบัญญัติของระเบียบข้อบังคับที่มีผลบังคับใช้ในปัจจุบัน
			และอื่น ๆ, กฎหมาย 34/2002 เกี่ยวกับบริการของ
			สังคมสารสนเทศและการพาณิชย์อิเล็กทรอนิกส์และระเบียบข้อบังคับ (EU) 2016/679 ของ
			รัฐสภายุโรปและสภา, วันที่ 27 เมษายน 2016, เกี่ยวกับ
			การคุ้มครองบุคคลธรรมดาเกี่ยวกับการประมวลผลข้อมูลส่วนบุคคล
			และการไหลเวียนของข้อมูลเหล่านี้โดยเสรีและโดยคำสั่ง 95/46/CE 
		</p>
		<h3>3. การเข้าถึงเว็บไซต์และการยอมรับ</h3>
		<p>
			การเข้าถึงเว็บไซต์เป็นเรื่องฟรียกเว้นในส่วนที่เกี่ยวข้องกับค่าใช้จ่ายในการเชื่อมต่อ
			ผ่านเครือข่ายโทรคมนาคมที่ให้บริการโดยผู้ให้บริการอินเทอร์เน็ต
			ที่คุณได้ทำสัญญา คุณสามารถท่องเว็บไซต์ได้อย่างอิสระ
			และเข้าถึงได้ทุกครั้งที่คุณต้องการ ในการเข้าถึงและท่องเว็บไซต์,
			คุณไม่จำเป็นต้องลงทะเบียน, ยกเว้นถ้าคุณต้องการจ้างบริการ
		</p>
		<p>
			การใช้เว็บไซต์ให้คุณมีสถานะเป็นผู้ใช้ของเว็บไซต์
			(ต่อไปนี้จะเรียกว่า "ผู้ใช้") และหมายถึงการยอมรับอย่างเต็มที่และไม่มีเงื่อนไขของคุณ
			ข้อกำหนดการใช้งานเหล่านี้, รวมถึง {privacyPolicyLink} และ {cookiesPolicyLink}
			ของเว็บไซต์ นอกจากนี้, คุณตกลงที่จะไม่ใช้บริการเพื่อวัตถุประสงค์ที่ผิดกฎหมาย
		</p>
		<p>
			โดยการเข้าถึงเว็บไซต์และท่องเว็บไซต์, คุณยืนยันตามความรับผิดชอบของคุณเองว่าคุณบรรลุนิติภาวะและมีความสามารถทางกฎหมายที่จำเป็นในการเข้าถึงเว็บไซต์และใช้งานได้,
			นอกจากนี้ยังประกาศว่าคุณเข้าใจและยอมรับข้อกำหนดการใช้งานเหล่านี้อย่างเต็มที่โดยไม่มีข้อสงวน
		</p>
		<p>
			ในทางกลับกัน, เราแจ้งให้คุณทราบว่าเนื่องจากเหตุผลทางกฎหมายเราเก็บบันทึกอิเล็กทรอนิกส์ที่การซื้อสินค้าถูกทำเป็นทางการ คุณสามารถเข้าถึง
			เอกสารเหล่านี้ได้ตลอดเวลาโดยการร้องขอที่: {supportLink}
		</p>
		<h3>4. เงื่อนไขการใช้เว็บไซต์</h3>
		<p>
			ผู้ใช้ตกลงที่จะใช้เว็บไซต์ตามเงื่อนไขการใช้งานเหล่านี้,
			กฎหมายปัจจุบันและความสุจริต ด้วยเหตุนี้, ผู้ใช้จะต้องตอบสนองต่อ {siteName}.
			 และก่อนบุคคลที่สามสำหรับความเสียหายและความสูญเสียที่เกิดจาก
			การใช้ในทางที่ขัดต่อเงื่อนไขเหล่านี้, กฎหมายและความสุจริตที่ทำ
			โดยผู้ใช้ของเว็บไซต์
		</p>
		<h3>5. คำอธิบายของบริการ</h3>
		<p>
			ผ่านบริการ, {siteName} อนุญาตให้สมัครบริการเพื่อ
			ดำเนินการแก้ไขภาพ
		</p>
		<p>
			ภาษาที่ใช้ในสัญญาระหว่าง {siteName} และผู้ซื้อ
			จะเป็นภาษาของประเทศต้นกำเนิด<br />
			กระบวนการซื้อในบริการออนไลน์จะเป็นดังนี้:
		</p>
		<ol>
			<li>คุณต้องลงทะเบียนในเว็บไซต์ด้วยชื่อผู้ใช้และรหัสผ่าน</li>
			<li>
				ในขณะที่ลงทะเบียน, ผู้ใช้ต้องเลือกหนึ่งในแผนการชำระเงิน
				ที่อยู่ในส่วนราคาจะได้รับเครดิตตาม
				แผนที่เลือก แต่ละเครดิตจะอนุญาตให้แก้ไขภาพหนึ่งภาพ
			</li>
			<li>
				หลังจากการซื้อบริการ, ผู้ใช้จะมีแผงการจัดการ
				ซึ่งพวกเขาจะพบ:
				<ul>
					<li>
						ส่วนที่มีรายการของภาพทั้งหมดที่ได้รับการประมวลผล, สามารถ
						แก้ไขได้หลายครั้งตามที่ต้องการและดาวน์โหลดไปยัง
						อุปกรณ์ของคุณ
					</li>
					<li>
						ส่วนแผนและการชำระเงินเพื่อปรึกษาใบแจ้งหนี้และยกเลิก
						การสมัครสมาชิก
					</li>
					<li>ส่วนบัญชีของฉันเพื่อเปลี่ยนการตั้งค่าบัญชี</li>
				</ul>
			</li>
		</ol>
		<p>
			เมื่อการซื้อบริการเสร็จสิ้น, จะได้รับการยืนยันโดย
			การส่งอีเมลภายในระยะเวลาไม่เกิน 24 ชั่วโมงไปยังที่อยู่ที่คุณได้
			ระบุ จะระบุบริการ, วิธีการยกเลิกการสมัครสมาชิก, จำนวนเงิน,
			ภาษีที่ใช้, วิธีการชำระเงินและข้อกำหนดและเงื่อนไขที่ใช้
		</p>
		<h4>5.1 การสมัครสมาชิก</h4>
		<p>
			การสมัครบริการจะแตกต่างกันไปตามแผนที่เลือกและจะถูก
			ต่ออายุโดยอัตโนมัติในระยะเวลาเดียวกันจนกว่าจะสิ้นสุด
			เว้นแต่คุณจะยกเลิกการสมัครสมาชิก, คุณอนุญาตให้เราทำการ
			เรียกเก็บค่าธรรมเนียมการสมัครสมาชิกประจำปีที่เกี่ยวข้องในวิธีการชำระเงินของคุณ
		</p>
		<p>
			คุณสามารถยกเลิกการสมัครสมาชิกบริการได้ทุกเมื่อและคุณจะ
			สามารถเข้าถึงมันจนกว่าจะสิ้นสุดรอบการเรียกเก็บเงินประจำปีของคุณ 
			เท่าที่กฎหมายอนุญาต, การชำระเงินไม่สามารถขอคืนได้และเราไม่ให้
			การคืนเงินหรือเครดิตสำหรับรอบการสมัครสมาชิกประจำปีที่บางส่วน
		</p>
		<h3>6. ราคาและภาษี</h3>
		<p>
			ราคาของผลิตภัณฑ์ที่นำเสนอใน {siteName} จะระบุเป็นยูโร
			(€) หรือสกุลเงินของประเทศที่ทำการซื้อ, ภาษีมูลค่าเพิ่ม (VAT)
			ในเวลาที่ซื้อจะถูกเรียกเก็บกับราคาของผลิตภัณฑ์
		</p>
		<p>
			ในกรณีใด ๆ, การดำเนินการอาจได้รับการยกเว้นหรือไม่อยู่ในภาษีขึ้นอยู่กับ
			ประเทศที่พำนักอาศัยของคุณหรือเงื่อนไขที่คุณดำเนินการ ดังนั้น,
			ในบางกรณีราคาสุดท้ายของการสั่งซื้ออาจมีการเปลี่ยนแปลงเมื่อเทียบกับ
			ราคาที่แสดง<br />
			การซื้อที่ทำโดยบุคคลที่ได้รับการยกเว้นจากการชำระภาษีมูลค่าเพิ่มจะระบุ
			ด้วยการส่งหมายเลข VAT/NIF ของพวกเขาทางอีเมลไปยัง {supportLink}, 
			การซื้อจะไม่ถูกบันทึกด้วยภาษีดังกล่าว
		</p>
		<h3>7. วิธีการชำระเงิน</h3>
		<p>
			การชำระเงินออนไลน์ของบริการที่ซื้อสามารถทำได้ด้วยบัตรเครดิตหรือบัตรเดบิต
			ในกรณีนี้, {siteName} แจ้งให้ผู้ถือบัตรเครดิตและบัตรเดบิตทราบว่า
			ธุรกรรมในร้านค้าออนไลน์จะดำเนินการผ่านทางเกตเวย์การชำระเงินที่ปลอดภัย,
			ใช้เทคโนโลยี SSL เพื่อรับประกันความปลอดภัยในการส่งข้อมูล
		</p>
		<h3>8. สิทธิ์ในการถอนและการคืนเงิน</h3>
		<h4>8.1. สิทธิ์ในการถอน</h4>
		<p>
			เนื่องจากประเภทของผลิตภัณฑ์ที่ทำการตลาดในบริการออนไลน์ของเรา,
			ซอฟต์แวร์ในรูปแบบดิจิทัลของ QR, สิทธิ์ในการถอนจะไม่สามารถใช้ได้ตาม
			บทความ 103, ตัวอักษร m) ของกฤษฎีกากฎหมายรอยัล 1/2007, วันที่ 16 พฤศจิกายน, 
			โดยที่ข้อความที่ผ่านการแก้ไขของกฎหมายทั่วไปว่าด้วยการคุ้มครองผู้บริโภคและ
			ผู้ใช้และกฎหมายเพิ่มเติมอื่น ๆ ได้รับการอนุมัติ
		</p>
		<h4>8.2. การคืนเงิน</h4>
		<p>
			ไม่ว่าผู้ใช้จะเลือกแผนใด, จำนวนเงินที่จ่ายโดยผู้ใช้และ
			เท่าที่กฎหมายอนุญาตจะไม่สามารถขอคืนได้
		</p>
		<p>
			บริการที่ทำสัญญาอาจไม่สามารถโอนหรือย้ายไปยังผู้ใช้บริการอื่น ๆ 
		</p>
		<p>
			ในกรณีใด ๆ, ผู้ใช้อาจใช้บริการที่ทำสัญญาได้จนกว่าจะสิ้นสุด
			ระยะเวลาที่ทำสัญญา
		</p>
		<h3>9. ความถูกต้องของข้อเสนอ</h3>
		<p>
			บริการที่นำเสนอในบริการและราคาของพวกเขาจะพร้อมสำหรับ
			การซื้อในขณะที่พวกเขาอยู่ในแคตาล็อกของบริการที่แสดงผ่านทางเว็บไซต์นี้
		</p>
		<p>
			ในกรณีใด ๆ, {siteName} ขอสงวนสิทธิ์ในการทำการแก้ไขใด ๆ 
			ตามที่เห็นว่าเหมาะสมในบริการ, สามารถอัปเดตผลิตภัณฑ์และบริการ
			ตามตลาด
		</p>
		<p>
			{siteName} ขอสงวนสิทธิ์ในการเปลี่ยนแปลงราคาด้วยการแจ้งล่วงหน้า
			เราแจ้งให้คุณทราบว่าแม้จะมีการอัปเดตราคาของบริการแล้ว, พวกเขาอาจมีข้อผิดพลาด
			เราจะแก้ไขข้อผิดพลาดที่เกิดขึ้นโดยเร็วที่สุด, แต่พวกเขาจะไม่เป็นข้อผูกพันกับบริการ
		</p>
		<h3>10. ความปลอดภัย</h3>
		<p>
			ดังที่กล่าวไว้ข้างต้น, กระบวนการซื้อทั้งหมด, เช่นเดียวกับการส่งข้อมูลส่วนบุคคลของคุณและระบบการชำระเงิน,
			ดำเนินการบนหน้าปลอดภัยและในลักษณะที่เข้ารหัสผ่านทางโปรโตคอล SSL
		</p>
		<p>
			เรารับประกันความปลอดภัยของบริการตามความรู้ทางเทคโนโลยีในปัจจุบัน 
			อย่างไรก็ตาม, {siteName} ไม่สามารถรับประกันความปลอดภัยในอนาคตของบริการได้ ในกรณีใด ๆ, เราสัญญาว่าจะแก้ไขและ
			ดำเนินมาตรการที่เหมาะสมในการแก้ไขการละเมิดความปลอดภัยที่เป็นไปได้โดยเร็วที่สุด
		</p>
		<p>
			คุณตกลงที่จะแจ้งให้ {siteName} ทราบทันทีและผ่านทางอีเมล {supportLink}
			ถึงสถานการณ์ใด ๆ ที่อาจนำไปสู่การแอบอ้างตัวตนของผู้ใช้
		</p>
		<h3>11. การแก้ไขและความเป็นโมฆะ</h3>
		<p>
			เราอาจอัปเดตข้อกำหนดและเงื่อนไขของบริการในอนาคต เช่นเดียวกับคุณสมบัติและฟังก์ชันของบริการเอง
		</p>
		<p>
			เราจะแจ้งให้คุณทราบถึงการเปลี่ยนแปลงในข้อกำหนดและเงื่อนไขโดยการวางประกาศ
			ในสถานที่ที่โดดเด่นบนเว็บไซต์ของเราและ/หรือทางอีเมล
		</p>
		<p>
			หากข้อใดข้อหนึ่งที่รวมอยู่ในข้อกำหนดและเงื่อนไขเหล่านี้ถูกประกาศให้เป็นโมฆะหรือไม่มีผลใช้, ทั้งหมดหรือบางส่วน, จะส่งผลกระทบเพียงแต่บทบัญญัติ
			หรือส่วนที่ไม่มีผลใช้เท่านั้น ข้อกำหนดและเงื่อนไขจะยังคงมีอยู่ในทุกอย่างอื่น ๆ,
			โดยบทบัญญัติที่ได้รับผลกระทบจะไม่มีการวาง
		</p>
		<h3>12. การเรียกร้องและการดำเนินการที่เกิดจากสัญญา</h3>
		<p>
			เท่าที่จะเป็นไปได้, บริการนี้ถูกควบคุมโดยกฎหมายของสเปน<br />
			เพื่อให้ง่ายต่อการแก้ไขการเรียกร้องผ่านกระบวนการทางแพ่งและ
			ลดค่าใช้จ่าย, เราไม่ปฏิเสธความเป็นไปได้ในการยื่นข้อเสนอ
			การอนุญาโตตุลาการเท่าที่ศาลอนุญาโตตุลาการของหอการค้าและอุตสาหกรรม 
			ในความหมายนี้และตามกฎระเบียบที่ใช้บังคับ, 
			{siteName} แจ้งให้ทราบถึงการมีอยู่ของแพลตฟอร์มการระงับข้อพิพาทออนไลน์ของยุโรปที่อำนวยความสะดวกในการระงับข้อพิพาทนอกศาลสำหรับ
			สัญญาที่ทำสัญญาออนไลน์ระหว่างผู้บริโภคและผู้ให้บริการอินเทอร์เน็ตด้วย แพลตฟอร์มนี้สามารถเข้าถึงได้ผ่านทางเว็บไซต์ต่อไปนี้:
			<a href="http://ec.europa.eu/odr" target="_blank">http://ec.europa.eu/odr</a>
		</p>
		<h3>13. สิทธิ์ในทรัพย์สินทางปัญญาและอุตสาหกรรม</h3>
		<p>
			เว็บไซต์และเนื้อหาของมันอยู่ภายใต้การคุ้มครองตาม
			กฎหมายแห่งชาติในปัจจุบันเกี่ยวกับทรัพย์สินทางปัญญาและ/หรือทรัพย์สินทางอุตสาหกรรม,
			เช่นเดียวกับการใช้ข้อตกลงระหว่างประเทศที่ใช้ในเรื่องนี้ {siteName} เป็นเจ้าของหรือได้รับการอนุญาตอย่างถูกต้องทั้งหมด
			สิทธิ์ในทรัพย์สินทางปัญญาและอุตสาหกรรมในเว็บไซต์และเนื้อหาของมัน
		</p>
		<p>
			รูปแบบใด ๆ ของการทำสำเนา, การแจกจ่าย, การสื่อสารสาธารณะ, การแปลง, การจัดให้พร้อมใช้งาน
			และโดยทั่วไป, การกระทำใด ๆ ของการหาประโยชน์ไม่ว่าจะมีวัตถุประสงค์ทางการค้าหรือไม่ในเว็บไซต์หรือเนื้อหาของมัน,
			โดยไม่ได้รับความยินยอมล่วงหน้าจาก {siteName} เป็นการห้ามอย่างเด็ดขาด การลบข้อมูลการระบุของ {siteName} 
			ในฐานะเจ้าของสิทธิ์ในทรัพย์สินทางปัญญาและอุตสาหกรรมในเว็บไซต์หรือเนื้อหาของมันอย่างชัดเจน
		</p>
		<p>
			{siteName} ขอสงวนสิทธิ์ในทรัพย์สินทางปัญญาและอุตสาหกรรมทั้งหมด
			ในเว็บไซต์และเนื้อหาของมัน, นอกจากนี้ยังสงวนสิทธิ์ในการดำเนินการทางกฎหมายใด ๆ ที่สอดคล้องกันเพื่อให้
			หยุด, ป้องกันหรือดำเนินการกับการใช้เว็บไซต์หรือเนื้อหาของมันอย่างผิดกฎหมาย ในกรณีใด ๆ 
			การเข้าถึงเว็บไซต์หรือการใช้งานโดยผู้ใช้หรือบุคคลที่สามในเว็บไซต์หรือเนื้อหาของมัน
			ไม่ถือว่าเป็นการโอนสิทธิ์ใด ๆ โดย {siteName} ในทรัพย์สินทางปัญญาหรืออุตสาหกรรม
			ในเว็บไซต์หรือเนื้อหาของมัน ในกรณีใด ๆ การขาดข้อกำหนดโดย {siteName} 
			ให้หยุดการใช้เว็บไซต์หรือการใช้เนื้อหาที่ผิดกฎหมายหรือขัดต่อเงื่อนไขเหล่านี้ไม่สามารถ
			เข้าใจว่าเป็นการยินยอมโดยปริยายโดย {siteName} ต่อการใช้ดังกล่าวหรือการสละสิทธิ์ในการดำเนินการทางกฎหมายใด ๆ ที่อาจสอดคล้องกัน
		</p>
		<h3>14. ความรับผิดชอบและการรับประกัน</h3>
		<p>
			ผู้ใช้ต้องใช้เว็บไซต์และเนื้อหาของมันตามข้อกำหนดการใช้งานเหล่านี้,
			กฎหมายปัจจุบันและความสุจริต การใช้เว็บไซต์หรือเนื้อหาของมันที่ขัดต่อ
			เงื่อนไขทั่วไปเหล่านี้, กฎหมายหรือความสุจริตอย่างชัดเจนไม่ว่า
			การใช้นั้นจะมีวัตถุประสงค์ทางเศรษฐกิจหรือไม่ก็ตาม<br />
			ผู้ใช้จะรับผิดชอบต่อความเสียหายหรือความสูญเสียใด ๆ ที่เกิดขึ้นกับ {siteName}
			 หรือบุคคลที่สามเนื่องจากการใช้งานเว็บไซต์หรือเนื้อหาของมันในทางที่ขัดต่อ
			เงื่อนไขเหล่านี้, กฎหมาย, ศีลธรรม, ระเบียบสาธารณะหรือความสุจริต
		</p>
		<p>
			เพื่อให้เว็บไซต์และเนื้อหาของมันสามารถเข้าถึงผู้ใช้, {siteName}
			 ต้องการบริการที่จัดหาโดยบุคคลที่สาม มีความเป็นไปได้ที่
			ถึงแม้ว่าจะมีความพยายามของ {siteName} ที่จะรักษาเว็บไซต์ให้พร้อม
			และเข้าถึงได้สำหรับผู้ใช้, การเข้าถึงอาจถูกระงับ, ขัดจังหวะหรือยกเลิก
			ด้วยเหตุผลที่อยู่นอกเหนือการควบคุมของ {siteName} นั่นคือเหตุผลที่ {siteName}
			ไม่รับประกันการขาดการหยุดชะงักหรือข้อผิดพลาดในการเข้าถึงเว็บไซต์หรือเนื้อหาของมัน,
			หรือว่ามันได้รับการอัปเดตหรือแสดงในเวอร์ชันล่าสุดอยู่เสมอ ดังนั้น, {siteName}
			ปฏิเสธความรับผิดชอบใด ๆ ต่อความเสียหายที่อาจเกิดขึ้นกับผู้ใช้หรือบุคคลที่สามอันเป็นผลมาจาก
			การระงับ, ขัดจังหวะ, การขาดความต่อเนื่อง, การขาดเครือข่าย
			หรือการตัดการเชื่อมต่อของเว็บไซต์
		</p>
		<p>
			ในกรณีใด ๆ และในภายหลัง {siteName} จะไม่รับผิดชอบต่อ
			ความเสียหายหรือความสูญเสียที่เกิดขึ้นกับผู้ใช้จากสาเหตุที่ไม่เกี่ยวข้องกับ {siteName}
			 เช่น, โดยวิธีการตัวอย่างและในกรณีที่ไม่มีข้อจำกัด, ภัยพิบัติทางธรรมชาติ, สถานการณ์ของเหตุสุดวิสัยหรือความเร่งด่วนที่สุด,
			ไวรัส, ส่วนประกอบที่เป็นอันตราย, การทำงานผิดพลาดของเบราว์เซอร์, การตกเครือข่าย, การบุกรุกคอมพิวเตอร์หรือ
			การโจมตีของบุคคลที่สาม
		</p>
		<h3>15. ลิงก์</h3>
		<p>
			เว็บไซต์, แพลตฟอร์ม, ฟอรัม, แชท, บล็อกหรือเครือข่ายสังคมภายนอกที่
			เชื่อมโยงหรือเชื่อมโยงกับเว็บไซต์ต้องแจ้งอย่างชัดเจนว่าไม่มี
			การอนุญาตหรือการตรวจสอบของ {siteName} และการเชื่อมโยงหรือการเชื่อมโยงนั้นไม่ได้เกี่ยวข้องกับ
			หรือไม่แสดงถึงการเชื่อมโยงใด ๆ ระหว่าง {siteName}
			 และเว็บไซต์, แพลตฟอร์ม, ฟอรัม, แชท, บล็อกหรือเครือข่ายสังคมภายนอกที่เชื่อมโยงหรือเชื่อมโยงกับเว็บไซต์
		</p>
		<p>
			ในกรณีใด ๆ, การเชื่อมโยงใด ๆ ที่มุ่งสู่เว็บไซต์ต้องมุ่งตรงไปยังหน้าแรกหรือหน้าแรกของเว็บไซต์
			โดยการคลิกที่ URL ของเว็บไซต์ที่ครอบคลุมหน้าจอทั้งหมดของหน้าแรกหรือหน้าแรกของ
			เว็บไซต์, เพื่อให้การเชื่อมโยงเป็นสมบูรณ์และสมบูรณ์โดยไม่มีการใช้
			เฟรม, เฟรมหรือไฮเปอร์ลิงก์ {siteName} ไม่ตอบสนองในกรณีใด ๆ 
			และภายใต้สถานการณ์ใด ๆ ต่อเนื้อหา, ข้อมูลหรือข้อมูลที่เกี่ยวข้องกับ
			เว็บไซต์, เนื้อหาของมันหรือเรื่องอื่นใดที่มีอยู่ในเว็บไซต์, แพลตฟอร์ม,
			ฟอรัม, แชท, บล็อกหรือเครือข่ายสังคมของบุคคลที่สามที่เชื่อมโยงหรือเชื่อมโยงกับเว็บไซต์
		</p>
		<p>
			ห้ามอย่างเด็ดขาดในการเชื่อมโยงหรือเชื่อมโยงกับเว็บไซต์จากเว็บไซต์,
			แพลตฟอร์ม, ฟอรัม, แชท, บล็อกหรือเครือข่ายสังคมที่ขัดต่อกฎหมาย, ศีลธรรม
			และความสุจริต, โดยเฉพาะอย่างยิ่งที่มีเนื้อหาลามก, ผิดกฎหมาย, หรือ
			ละเมิดสิทธิมนุษยชน
		</p>
		<p>
			ในทางกลับกัน, เว็บไซต์อาจมีลิงก์ไปยังเว็บไซต์ของบุคคลที่สาม,
			แพลตฟอร์ม, ฟอรัม, แชท, บล็อกหรือเครือข่ายสังคม {siteName} ไม่มี
			วิธีการทางมนุษย์และ/หรือทางเทคนิคในการทราบหรือควบคุมข้อมูลและ
			เนื้อหาที่ปรากฏบนเว็บไซต์ของบุคคลที่สาม ดังนั้น, ในกรณีใด {siteName}
			 จะไม่รับผิดชอบต่อเนื้อหาของเว็บไซต์ที่เชื่อมโยงและภายใต้
			สถานการณ์ใด ๆ การเชื่อมโยงเหล่านี้ไม่สามารถถือว่าเป็นความรู้ที่มีประสิทธิภาพของเนื้อหา
			ของเว็บไซต์ที่พวกเขาเชื่อมโยงถึง
		</p>
		<h3>16. การคุ้มครองข้อมูล</h3>
		<p>
			ตามที่ระบุใน {privacyPolicyLink} ของมัน, {siteName} ตกลงที่จะใช้ข้อมูลของผู้ใช้,
			เพื่อเคารพความลับของมันและใช้ตาม
			วัตถุประสงค์ของการรักษา, เช่นเดียวกับการปฏิบัติตามข้อผูกพันในการบันทึกมัน
			และปรับมาตรการทั้งหมดเพื่อหลีกเลี่ยงการเปลี่ยนแปลง, การสูญหาย, การรักษา หรือการเข้าถึงที่ไม่ได้รับอนุญาต
			ตามบทบัญญัติของกฎหมายที่เกี่ยวข้องกับการคุ้มครองข้อมูลส่วนบุคคล
		</p>
		<p>
			เว็บไซต์นี้มีการป้องกันที่เหมาะสมและใช้เทคโนโลยีมาตรฐานอุตสาหกรรม
			เพื่อปรับปรุงความปลอดภัย, ความสมบูรณ์, ความสมบูรณ์, ความถูกต้องและ
			การคุ้มครองข้อมูลส่วนบุคคลที่ได้รวบรวม, และได้มีการตั้ง
			มาตรการป้องกันที่สมเหตุสมผลเพื่อปกป้องข้อมูลดังกล่าวจากการสูญหายหรือ
			การใช้งานผิดพลาดที่เป็นไปได้ กฎเกณฑ์เกี่ยวกับการคุ้มครองข้อมูลและความปลอดภัยของมันจะได้รับการตรวจสอบ
			และปรับปรุงเมื่อจำเป็น, และพยายามที่จะให้แน่ใจว่ามีเพียงบุคคลที่ได้รับอนุญาตเท่านั้น
			ที่สามารถเข้าถึงข้อมูลที่ผู้ใช้ให้ไว้
		</p>
		<p>
			เพื่อทราบข้อมูลเพิ่มเติมเกี่ยวกับการจัดการและการประมวลผลที่ดำเนินการโดย {siteName}
			 ของข้อมูลของคุณ, โปรดอ่าน {privacyPolicyLink} และ {cookiesPolicyLink} ของเรา
		</p>
		<h3>17. ระยะเวลาและการแก้ไข</h3>
		<p>
			เงื่อนไขการใช้งานเหล่านี้จะมีผลบังคับใช้ตราบเท่าที่พวกเขาถูกเปิดเผยต่อ
			ผู้ใช้, ดังนั้นทันทีที่พวกเขาได้รับการแก้ไขหรืออัปเดตทั้งหมดหรือบางส่วน,
			เงื่อนไขเหล่านี้จะหยุดมีผลบังคับใช้, โดยเงื่อนไขการใช้งานใหม่จะเข้ามาควบคุม
			การใช้เว็บไซต์
		</p>
		<p>
			{siteName} ขอสงวนสิทธิ์ในการตรวจสอบ, แก้ไขหรืออัปเดตเงื่อนไขการใช้งานเหล่านี้
			ได้ตลอดเวลา ในกรณีที่มีการเปลี่ยนแปลงใด ๆ ในเงื่อนไขการใช้งานเหล่านี้ด้วยเหตุผลใดก็ตาม, 
			{siteName} จะแจ้งให้ผู้ใช้ทราบในหน้าแรกของ
			เว็บไซต์เกี่ยวกับสถานการณ์ดังกล่าวเพื่อให้พวกเขาได้รับข้อมูลที่เหมาะสมและสามารถตรวจสอบ
			การแก้ไข, การเปลี่ยนแปลงหรือการอัปเดตของเงื่อนไขการใช้งานปัจจุบันนี้
			ให้เป็นที่พึงพอใจของพวกเขา
		</p>
		<h3>18. ทั่วไป</h3>
		<p>
			ในกรณีใด ๆ และภายใต้สถานการณ์ใด ๆ การขาดการใช้สิทธิ์ของคุณ
			โดย {siteName} ไม่สามารถเข้าใจว่าเป็นการสละสิทธิ์
		</p>
		<p>
			หัวข้อที่มีอยู่ในเงื่อนไขเหล่านี้เป็นเพียงเพื่อบ่งชี้หรือ
			ข้อมูลเท่านั้น, ดังนั้นพวกเขาจะไม่มีผลกระทบ, คุณภาพหรือขยายการตีความ
		</p>
		<p>
			ในกรณีที่ข้อใดข้อหนึ่งของเงื่อนไขเหล่านี้ถูกประกาศให้เป็นโมฆะ, ใช้อำนาจบาตรใหญ่
			หรือไม่สามารถบังคับใช้ได้, ทั้งหมดหรือบางส่วน, โดยหน่วยงานการพิจารณาคดีหรือการบริหาร,
			การประกาศดังกล่าวจะส่งผลเฉพาะข้อที่
			เป็นปัญหา, การประกาศดังกล่าวจะไม่ขยายภายใต้สถานการณ์ใด ๆ ไปยังส่วนที่เหลือของ
			เงื่อนไขซึ่งจะยังคงอยู่
		</p>
		<p>
			เงื่อนไขการใช้งานเหล่านี้เช่นเดียวกับ {privacyPolicyLink} และ {cookiesPolicyLink}
			จะถูกควบคุมโดยกฎหมายสเปนที่มีผลบังคับใช้ในปัจจุบัน
		</p>
		<h3>19. บริการลูกค้า</h3>
		<p>
			สำหรับคำชี้แจง, เหตุการณ์หรือการเรียกร้องใด ๆ คุณสามารถติดต่อเราได้ทาง:<br />
			อีเมล: {supportLink}<br />
			ที่อยู่ไปรษณีย์: Av. Cerdanyola, 75 - 1º, CP 08172, Sant Cugat del Vallés, Barcelona, Spain
		</p>`
	},
	privacyPolicy: {
		lastUpdate: 'อัปเดตล่าสุด: 10 มิถุนายน 2024',
		content: `
			<h3>1. ผู้รับผิดชอบและคำอธิบาย</h3>
			<h5>1.1. ผู้รับผิดชอบ</h5>
			<p>ผู้รับผิดชอบในการดำเนินการของเว็บไซต์นี้คือ Remove Background S.L (ต่อไปนี้จะเรียกว่า Remove Background 
			หรือบริการ), มีที่อยู่ที่ Av. Cerdanyola, 75 - 1º, CP 08172, Sant Cugat del Vallés, Barcelona, Spain</p>
			<p>NIF: B56768260<br> อีเมล: {supportLink}</p>

			<h5>1.2. คำอธิบาย</h5>
			<p>การยอมรับนโยบายความเป็นส่วนตัวของ Remove Background (ต่อไปนี้จะเรียกว่า "นโยบายความเป็นส่วนตัว"), 
				เป็นเงื่อนไขที่จำเป็นสำหรับการใช้เว็บไซต์ของเราและการให้บริการ (ต่อไปนี้จะเรียกว่า "บริการ").<br>
				นโยบายความเป็นส่วนตัวนี้ควบคุมการเก็บรวบรวม, การประมวลผล และการใช้งานข้อมูลส่วนบุคคลและไม่ใช่ส่วนบุคคลของคุณ 
				ในฐานะผู้ใช้ของ Remove Background, ณ วันที่มีผลบังคับใช้ที่ปรากฏในหัวเรื่อง.<br>
				ในการประมวลผลข้อมูลส่วนบุคคลของคุณ, Remove Background ปฏิบัติตามกฎหมายท้องถิ่นและยุโรปที่มีผลบังคับใช้,
				รวมถึงกฎระเบียบการบังคับใช้ของมัน</p>


			<h3>2. ข้อมูลที่เก็บรวบรวม</h3>
			<p>การเข้าถึงเว็บไซต์ของเราสามารถทำได้โดยไม่ต้องให้ข้อมูลใด ๆ, แม้ว่าการลงทะเบียนและ/
				หรือการทำสัญญาแผนการของเราคุณจะต้องให้ข้อมูลส่วนบุคคลบางอย่างแก่เรา ข้อมูล (ส่วนบุคคล
				หรือไม่ใช่ส่วนบุคคล) ที่เก็บรวบรวมโดยบริการอาจแตกต่างกันไปตามนั้น.<br>
				ข้อมูลส่วนบุคคลและไม่ใช่ส่วนบุคคลที่เก็บรวบรวมโดยบริการจะมาหาเราด้วยสามวิธี: 1) ที่เก็บรวบรวมโดยอัตโนมัติ 2) ที่คุณให้เราโดยสมัครใจและ 3) ที่ให้โดยบุคคลที่สาม</p>

			<h5>2.1. ข้อมูลที่เก็บรวบรวมโดยอัตโนมัติ</h5>
			<p>ข้อมูลนี้จะประกอบด้วย:</p>
			<ul>
				<li>ข้อมูลที่เก็บรวบรวมผ่านคุกกี้หรือกลไกที่คล้ายกันที่เก็บไว้ในอุปกรณ์ของคุณ, โดยได้รับความยินยอมจากคุณหรือ
					ตามฐานกฎหมายอื่น ๆ ตรวจสอบนโยบายคุกกี้ของเราเพื่อดูข้อมูลเพิ่มเติม</li>
				<li>IP ที่เชื่อมต่อ, ประเภทของอุปกรณ์ที่ใช้และลักษณะของมัน, เวอร์ชันของระบบปฏิบัติการ,
					ประเภทของเบราว์เซอร์, ภาษา, วันที่, ประเทศ, เวลาของการร้องขอ, 
					URL ที่คุณมาจาก, URL ที่คุณไปหรือเครือข่ายมือถือที่ใช้, เป็นต้น</li>
				<li>ข้อมูลการใช้บริการและข้อผิดพลาดที่อาจตรวจพบในระหว่างการใช้งาน</li>
				<li>นอกจากนี้, Remove Background ใช้ Google Analytics, บริการวิเคราะห์ที่ให้บริการโดย Google, LLC 
					ตั้งอยู่ในสหรัฐอเมริกาที่มีสำนักงานใหญ่ที่ 1600 Amphitheater Parkway, Mountain View, California 94043. 
					ในการให้บริการเหล่านี้, พวกเขาใช้คุกกี้ที่เก็บข้อมูลรวมถึงที่อยู่ IP ของผู้ใช้, 
					ซึ่งจะถูกส่ง, ประมวลผลและเก็บโดย Google ตามเงื่อนไขที่ระบุในเว็บ www.google.com. 
					รวมถึงการส่งข้อมูลดังกล่าวไปยังบุคคลที่สามตามความต้องการทางกฎหมายหรือ
					เมื่อบุคคลที่สามดังกล่าวประมวลผลข้อมูลในนามของ Google</li>
			</ul>
			<p>ในกรณีใด ๆ, คุณสามารถปิดการใช้งานคุกกี้ Google Analytics ได้จาก <a href="{externalLink: disableGoogleAnalyticsLink}">ที่นี่</a></p>

			<h5>2.2. ข้อมูลที่คุณให้เราโดยสมัครใจ</h5>
			<p>ข้อมูลนี้จะประกอบด้วย:</p>
			<ul>
				<li>ข้อมูลทั้งหมดเป็นสิ่งจำเป็น</li>
				<li>ข้อมูลที่จำเป็นสำหรับ Remove Background ในการลงทะเบียนของคุณบนเว็บ: ชื่อและนามสกุล, ที่อยู่และอีเมล, เป็นต้น</li>
				<li>ข้อมูลทั้งหมดเป็นสิ่งจำเป็น</li>
				<li>ข้อมูลส่วนบุคคลหรือไม่ใช่ส่วนบุคคลที่จำเป็นสำหรับการทำสัญญาบริการเช่นที่อยู่อีเมลของคุณและหมายเลขบัตรเครดิตหรือบัตรเดบิตของคุณ</li>
				<li>ข้อมูลส่วนบุคคลหรือไม่ใช่ส่วนบุคคลที่ข้อความที่ส่งผ่านช่องทางการติดต่อหรือความคิดเห็นที่จัดตั้งขึ้นในบริการอาจมี, 
					เช่นชื่อและอีเมลของคุณ</li>
			</ul>

			<h5>2.3. ข้อมูลที่ให้โดยบุคคลที่สาม</h5>
			<p>ข้อมูลนี้จะประกอบด้วย:</p>
			<ul>
				<li>ข้อมูลที่ให้โดยระบบการชำระเงินหรือผู้ประมวลผลบัตรเครดิต, เช่นเวลาของการซื้อหรือจำนวนเงินของมัน</li>
			</ul>


			<h3>3. สิทธิและวัตถุประสงค์</h3>
			<p>เราขอแจ้งให้คุณทราบว่าการกรอกแบบฟอร์มเป็นเรื่องสมัครใจ อย่างไรก็ตาม, หากคุณไม่กรอกช่องที่จำเป็น
				(มักถูกระบุด้วยดอกจัน), การใช้ฟังก์ชันบางอย่างของบริการจะไม่สามารถทำได้หรือจะถูกจำกัด.<br>
				ข้อมูลส่วนบุคคลที่คุณให้เราจะถูกรวมและประมวลผลในบันทึกกิจกรรมการประมวลผลของ Remove Background 
				เพื่อให้สามารถตอบสนองคำขอของคุณ, ให้บริการที่ร้องขอและแจ้งคุณเกี่ยวกับเรื่องที่เกี่ยวข้องกับกิจกรรม 
				ของบริษัทและบริการของมัน.<br>
				คุณสามารถใช้สิทธิ์ในการเข้าถึง, แก้ไข, ลบ, จำกัดการประมวลผลของคุณ, 
				คัดค้านและโอนข้อมูลส่วนบุคคลของคุณได้ทุกเมื่อโดยส่งอีเมลถึง: {supportLink} หรือที่อยู่ไปรษณีย์: 
				Av. Cerdanyola, 75 - 1º, CP 08172, Sant Cugat del Vallés, Barcelona, Spain.<br>
				ในทั้งสองกรณี, คุณต้องระบุชื่อและนามสกุลของคุณเช่นเดียวกับสำเนาของ DNI หรือบัตรประชาชนของคุณถ้าจำเป็น.<br>
				ในกรณีที่คุณได้ให้ความยินยอมสำหรับวัตถุประสงค์เฉพาะ, คุณมีสิทธิ์ที่จะถอนความยินยอมได้ทุกเมื่อ, 
				โดยไม่กระทบต่อความถูกต้องตามกฎหมายของการประมวลผลที่อิงตามความยินยอมก่อนที่จะถอน.<br>
				นอกจากนี้, หากคุณคิดว่ามีปัญหาเกี่ยวกับวิธีที่ Remove Background จัดการข้อมูลของคุณ, 
				คุณสามารถยื่นเรื่องร้องเรียนกับ <a href="{knowYourRightsLink}">หน่วยงานคุ้มครองข้อมูล</a> ที่เกี่ยวข้อง, ซึ่ง <a href="{aepdLink}">สำนักงานคุ้มครองข้อมูลแห่งสเปน</a> 
				เป็นหน่วยงานที่ระบุในกรณีของสเปน</p>


			<h3>4. อายุ</h3>
			<p>เกี่ยวกับการใช้บริการออนไลน์, คุณยืนยันว่าคุณเป็นผู้บรรลุนิติภาวะและมีความสามารถทางกฎหมายที่จำเป็น 
				ที่จะผูกพันกับข้อตกลงนี้และใช้ไซต์ตามเงื่อนไขและข้อกำหนดที่คุณเข้าใจและรับทราบอย่างเต็มที่.<br>
				คุณยืนยันว่าข้อมูลทั้งหมดที่คุณให้เพื่อเข้าถึงบริการ, ก่อนและระหว่างการใช้งาน, เป็นความจริง, ครบถ้วน
				และถูกต้อง</p>


			<h3>5. การใช้ข้อมูล</h3>
			<p>Remove Background จะใช้ข้อมูลที่เก็บรวบรวมเพื่อ:</p>
			<ul>
				<li>จัดการและอัปเดตบริการ (ฐานกฎหมายของเราคือความสนใจที่ถูกต้องในการรักษาและรักษาบริการให้อัปเดตและอยู่ในสภาพดี)</li>
				<li>ตอบคำถามที่คุณยกขึ้น (ฐานกฎหมายของเราคือความสนใจที่ถูกต้องในการตอบคำขอและ
					ข้อสงสัยของผู้ใช้ของเรา)</li>
				<li>ประมวลผลการชำระเงินที่คุณทำ (ฐานกฎหมายคือสัญญา)</li>
				<li>ให้บริการที่ทำสัญญา (ฐานกฎหมายคือสัญญา)</li>
				<li>รักษาความปลอดภัยของบริการ, สืบสวนกิจกรรมที่ผิดกฎหมาย, บังคับใช้ข้อกำหนดและเงื่อนไขของเราและ
					ช่วยเหลือเจ้าหน้าที่ความมั่นคงของรัฐในกรอบการสืบสวนของพวกเขา (ฐานกฎหมายของเราคือความสนใจที่ถูกต้องในการรับประกันและรักษาความปลอดภัยของบริการและผู้ใช้ของมัน)</li>
			</ul>
			<p>Remove Background ไม่ใช้การตัดสินใจที่อัตโนมัติ, แม้ว่าจะสามารถสร้างโปรไฟล์ผู้ใช้พื้นฐาน, 
				ฐานกฎหมายของเราคือความสนใจที่ถูกต้องสำหรับวัตถุประสงค์ทางการค้าและการเสนอราคาที่ปรับให้เหมาะสม.<br>
				นอกจากนี้, Remove Background อาจใช้ข้อมูลผู้ใช้ในรูปแบบข้อมูลรวมและไม่เปิดเผยตัวตนเพื่อแสดงให้กับบุคคลที่สาม 
				คุณยังสามารถแบ่งปันสถิติและข้อมูลประชากรเกี่ยวกับผู้ใช้และการใช้บริการกับบุคคลที่สาม 
				แต่ไม่มีสิ่งนี้จะอนุญาตให้บุคคลที่สามเหล่านั้นระบุคุณเป็นการส่วนตัวได้</p>

			<h5>5.1. ในอีเมลและแบบฟอร์มการติดต่อ</h5>
			<p>เว็บไซต์มีการเข้ารหัส SSL ที่อนุญาตให้ผู้ใช้ส่งข้อมูลส่วนบุคคลอย่างปลอดภัยผ่านแบบฟอร์มการติดต่อมาตรฐาน.<br>
				ข้อมูลส่วนบุคคลที่เก็บรวบรวมจะถูกประมวลผลอัตโนมัติและรวมอยู่ในไฟล์ที่สอดคล้องของ 
				บันทึกกิจกรรมการประมวลผลและของ Remove Background</p>
			<p>ในเรื่องนี้:</p>
			<ul>
				<li>เราจะได้รับที่อยู่ IP ของคุณ, ซึ่งจะใช้ในการตรวจสอบที่มาของข้อความเพื่อเสนอข้อเสนอแนะที่เหมาะสม (เช่น แสดงข้อมูลในภาษาที่ถูกต้อง) และเพื่อตรวจหาความผิดปกติที่เป็นไปได้ 
					(เช่น ความพยายามในการโจมตีทางไซเบอร์ต่อบริการ), รวมถึงข้อมูลที่เกี่ยวข้องกับ ISP ของคุณ</li>
				<li>เช่นเดียวกัน, คุณสามารถให้ข้อมูลของคุณผ่านโทรศัพท์, อีเมลและวิธีการติดต่ออื่น ๆ ที่ระบุไว้</li>
			</ul>
			<p>เกี่ยวกับวิธีการชำระเงินที่ใช้:</p>
			<ul>
				<li>ผู้ให้บริการการชำระเงินของเราสำหรับการชำระเงินเพื่อการให้บริการของเราคือบัตรเครดิตหรือบัตรเดบิต 
					ในกรณีใด ๆ บริการหรือพนักงานของมันจะไม่มีการเข้าถึงข้อมูลธนาคาร (เช่น หมายเลขบัตรเครดิต) 
					ที่ผู้ใช้ในฐานะลูกค้าจะให้แก่บุคคลที่สามเหล่านั้น</li>
			</ul>


			<h3>6. การเก็บรักษาข้อมูล</h3>
			<p>ด้านล่าง, จะแสดงระยะเวลาที่ข้อมูลที่ประมวลผลโดยบริการจะถูกเก็บรักษา:</p>
			<ul>
				<li>ข้อมูลที่แยกออกจะถูกเก็บไว้โดยไม่มีระยะเวลาการลบ</li>
				<li>
					ข้อมูลลูกค้าจะถูกเก็บรักษาไว้ให้น้อยที่สุด, และอาจถูกเก็บรักษาไว้จนถึง:
					<ul>
						<li>5 ปี, ตามกฎหมายศิลปะ. 1964 ของประมวลกฎหมายแพ่ง (การกระทำส่วนบุคคลโดยไม่มีระยะเวลาพิเศษ)</li>
						<li>6 ปี, ตามกฎหมายศิลปะ. 30 ของประมวลกฎหมายพาณิชย์ (หนังสือบัญชีหรือใบแจ้งหนี้, เป็นต้น)</li>
					</ul>
				</li>
				<li>ข้อมูลผู้ใช้จะถูกเก็บไว้สูงสุด 12 เดือนเพื่อตอบคำขอของพวกเขา</li>
			</ul>


			<h3>7. ข้อมูลที่แบ่งปันกับบุคคลที่สาม</h3>
			<p>มีบุคคลที่สามที่จัดการส่วนหนึ่งของบริการ.<br>
				Remove Background ต้องการให้พวกเขาปฏิบัติตามนโยบายความเป็นส่วนตัวนี้ตามที่บังคับใช้กับพวกเขา, นอกเหนือจากการมีนโยบายของตนเอง. อย่างไรก็ตาม, Remove Background จะไม่รับผิดชอบต่อการปฏิบัติตามนโยบายดังกล่าว.<br>
				ในบางสถานการณ์, Remove Background อาจแบ่งปัน, ใช้ หรือเก็บรักษากับบุคคลที่สามข้อมูลส่วนบุคคลใด ๆ ที่เก็บรวบรวม:</p>
			<ul>
				<li>เพื่อให้บริการ:</li>
			</ul>
			<p>ผู้ให้บริการที่ดำเนินการในนามของเรา, เช่น บริการการชำระเงิน, การโฮสต์เว็บ, การวิเคราะห์ธุรกิจ, การบริการลูกค้า, หรือการตลาดเว็บ. ผู้ให้บริการเหล่านี้อาจเก็บรวบรวมและเข้าถึงข้อมูลที่จำเป็นสำหรับพวกเขาในการดำเนินการ, แต่พวกเขาไม่ได้รับอนุญาตให้แบ่งปันหรือใช้ข้อมูลเพื่อวัตถุประสงค์อื่นใด</p>
			<ul>
				<li>เพื่อความร่วมมือกับหน่วยงานที่มีอำนาจ:</li>
			</ul>
			<p>ถ้าเราเชื่อว่ามันจำเป็นอย่างสมเหตุสมผลในการตอบสนองความต้องการทางกฎหมายใด ๆ, กระบวนการทางกฎหมาย หรือผลประโยชน์ที่ถูกต้อง. ในกรณีใด ๆ, เราจะให้ข้อมูลที่จำเป็นอย่างเคร่งครัดเท่านั้น</p>


			<h3>8. มาตรการรักษาความปลอดภัย</h3>
			<p>Remove Background นำมาตรการทางเทคนิคและองค์กรทั้งหมดที่จำเป็นเพื่อ
				ปกป้องความปลอดภัยและความสมบูรณ์ของข้อมูลส่วนบุคคลและไม่ใช่ส่วนบุคคลที่เก็บรวบรวม. 
				ทั้งต่อต้านการเข้าถึงที่ไม่ได้รับอนุญาตและการเปลี่ยนแปลงโดยไม่ได้ตั้งใจ, การสูญหายหรือการทำลาย.<br>
				ในกรณีใด ๆ, Remove Background ไม่สามารถรับประกันความปลอดภัยสมบูรณ์ของข้อมูลที่เก็บรวบรวม, 
				ดังนั้นคุณต้องร่วมมือและใช้ความระมัดระวังเกี่ยวกับข้อมูลที่แชร์ตลอดเวลา.<br>
				คุณเข้าใจและยอมรับว่า, แม้หลังจากการลบ, ข้อมูลส่วนบุคคลและไม่ใช่ส่วนบุคคลอาจยังคงสามารถดูได้ในแคชหรือ 
				หากมีการคัดลอกหรือเก็บโดยผู้ใช้อื่น ๆ</p>


			<h3>9. การเปลี่ยนแปลงนโยบายความเป็นส่วนตัว</h3>
			<p>เราอาจอัปเดตนโยบายความเป็นส่วนตัวนี้ในอนาคต. เราจะแจ้งให้คุณทราบถึงการเปลี่ยนแปลงของมันโดยการส่งการแจ้งเตือนไปยังที่อยู่อีเมลที่ให้ไว้และ/หรือโดยการวางการแจ้งเตือนในสถานที่ที่โดดเด่นบนเว็บไซต์ของเรา</p>


			<h3>10. การติดต่อ</h3>
			<p>หากคุณมีคำถามเกี่ยวกับนโยบายความเป็นส่วนตัวนี้, ติดต่อเราที่:</p>
			<p>อีเมล: {supportLink}<br> 
				ที่อยู่: Av. Cerdanyola, 75 - 1º, CP 08172, Sant Cugat del Vallés, Barcelona, Spain</p>
		`
	},
	gdpr: {
		lastUpdate: 'อัปเดตล่าสุด: 10 มิถุนายน 2024',
		content: `
			<h3>1. ใครเป็นผู้รับผิดชอบและติดต่อได้อย่างไร?</h3>
			<p>ผู้ควบคุมของเว็บไซต์นี้คือ Remove Background S.L โดยมีที่อยู่ที่ Av. Cerdanyola, 75 - 1º, CP 08172, Sant Cugat del Vallés, Barcelona, Spain</p>
			<p>คุณสามารถติดต่อเขาได้ทางอีเมลที่ {supportLink}</p>

			<h3>2. ข้อมูลใดบ้างที่ถูกรวบรวม?</h3>
			<p>
				เรารวบรวมข้อมูลโดยอัตโนมัติผ่านคุกกี้ที่เราติดตั้งในอุปกรณ์ของคุณ, รวมถึงการวิเคราะห์ 
				เรายังรวบรวม IP ที่ทำการเชื่อมต่อ, ประเภทของอุปกรณ์ที่ใช้และลักษณะของมัน, 
				เวอร์ชันของระบบปฏิบัติการ, ประเภทของเบราว์เซอร์, ภาษา, วันที่, ประเทศ, เวลาของการร้องขอ, 
				URL ที่คุณมาจาก, URL ที่คุณไปหรือเครือข่ายมือถือที่ใช้, เป็นต้น.<br>
				โดยสมัครใจผู้ใช้ให้ข้อมูลบางอย่างเช่นชื่อและนามสกุล, อีเมลหรือข้อมูลธนาคาร 
				เพื่อให้สามารถติดต่อเรา, ลงทะเบียนเพื่อใช้บริการหรือซื้อการสมัครสมาชิก
			</p>

			<h3>3. ข้อมูลที่ถูกรวบรวมใช้ทำอะไร?</h3>
			<p>
				บริการจะใช้ข้อมูลที่ถูกรวบรวม, ในการจัดการและอัปเดตบริการ, ตอบคำขอของคุณ, 
				ส่งจดหมายข่าวของเราและข้อเสนอโปรโมชั่นทางอีเมล, จัดการการลงทะเบียนของคุณบนแพลตฟอร์ม, จัดการและให้บริการ 
				ที่เกี่ยวข้องกับการสมัครสมาชิกของคุณ, ประมวลผลการชำระเงินที่คุณทำและออกใบแจ้งหนี้ที่เกี่ยวข้อง, 
				รักษาความปลอดภัยของบริการ, สืบสวนกิจกรรมที่ผิดกฎหมาย, บังคับใช้ข้อกำหนดและเงื่อนไขของเราและ 
				ช่วยเหลือเจ้าหน้าที่ความมั่นคงของรัฐในกรอบการสืบสวนของพวกเขา
			</p>

			<h3>4. เก็บรักษาข้อมูลไว้นานแค่ไหน?</h3>
			<ul>
				<li>ข้อมูลที่แยกออกจะถูกเก็บไว้โดยไม่มีระยะเวลาการลบ</li>
				<li>
					ข้อมูลลูกค้าจะถูกเก็บรักษาให้น้อยที่สุด, และอาจถูกเก็บรักษาไว้จนถึง:
					<ul>
						<li>5 ปี, ตามกฎหมายศิลปะ. 1964 ของประมวลกฎหมายแพ่ง (การกระทำส่วนบุคคลโดยไม่มีระยะเวลาพิเศษ)</li>
						<li>6 ปี, ตามกฎหมายศิลปะ. 30 ของประมวลกฎหมายพาณิชย์ (หนังสือบัญชีหรือใบแจ้งหนี้, เป็นต้น)</li>
					</ul>
				</li>
				<li>ข้อมูลผู้ใช้จะถูกเก็บไว้สูงสุด 12 เดือนเพื่อตอบคำขอของพวกเขา</li>
				<li>ข้อมูลผู้ใช้ที่อัปโหลดโดยบริการไปยังหน้าและโปรไฟล์ในเครือข่ายสังคมจะถูกเก็บรักษาตั้งแต่ผู้ใช้ให้ความยินยอมจนถึงการถอน</li>
			</ul>

			<h3>5. สิทธิ์ของคุณในฐานะผู้ใช้คืออะไร?</h3>

			<p>
				สิทธิ์ในการเข้าถึง: ผู้ที่ได้รับผลกระทบจะมีสิทธิ์ที่จะได้รับการยืนยันจากผู้ควบคุมข้อมูลว่ามีการประมวลผลข้อมูลส่วนบุคคลที่เกี่ยวข้องกับเขาหรือไม่
			</p>
			<p>
				สิทธิ์ในการแก้ไข: ผู้ที่ได้รับผลกระทบจะมีสิทธิ์ที่จะได้รับ, โดยไม่ชักช้า, การแก้ไขข้อมูลส่วนบุคคลที่ไม่ถูกต้องที่เกี่ยวข้องกับเขาโดยผู้ควบคุมข้อมูล 
				นอกจากนี้, ผู้ที่ได้รับผลกระทบจะมีสิทธิ์ที่จะเสร็จสมบูรณ์ข้อมูลส่วนบุคคลที่ไม่สมบูรณ์, รวมถึงโดยการประกาศเพิ่มเติม
			</p>
			<p>
				สิทธิ์ในการลบ: สิทธิ์ของผู้ที่ได้รับผลกระทบในการลบข้อมูลส่วนบุคคลที่เกี่ยวข้องกับเขาโดยไม่ชักช้า, โดยผู้ควบคุมข้อมูล
			</p>
			<p>
				สิทธิ์ในการจำกัดการประมวลผลข้อมูล: ประกอบด้วยการได้รับการจำกัดการประมวลผลข้อมูลของคุณโดยผู้ควบคุมข้อมูล, แม้ว่าการใช้สิทธินี้จะมีสองแง่มุม: 1) เมื่อคุณท้าทายความถูกต้องของข้อมูลส่วนบุคคลของคุณ, ในระหว่างช่วงเวลาที่อนุญาตให้ผู้ควบคุมข้อมูลตรวจสอบได้ และ 2) เมื่อคุณคัดค้านการประมวลผลข้อมูลส่วนบุคคลของคุณที่ผู้ควบคุมข้อมูลดำเนินการบนพื้นฐานของความสนใจที่ถูกต้องหรือภารกิจสาธารณะ, ในขณะที่ผู้ควบคุมข้อมูลตรวจสอบว่าความสนใจเหล่านี้มีความสำคัญกว่า
			</p>
			<p>
				สิทธิ์ในการโอนข้อมูล: สิทธิ์ของผู้ที่ได้รับผลกระทบในการรับข้อมูลส่วนบุคคลที่เกี่ยวข้องกับเขา, 
				ที่เขาได้ให้กับผู้ควบคุมข้อมูล, ในรูปแบบที่มีโครงสร้าง, ใช้งานทั่วไปและอ่านได้ด้วยเครื่องจักร, และ
				ถ่ายโอนไปยังผู้ควบคุมข้อมูลอื่นโดยไม่ถูกกีดกันโดยผู้ควบคุมข้อมูลที่เขาให้ไว้
			</p>
			<p>
				ในความหมายนี้, ผู้ที่ได้รับผลกระทบจะมีสิทธิ์ที่จะให้ข้อมูลส่วนบุคคลถูกส่งตรงจากผู้ควบคุมข้อมูล
				ไปยังผู้ควบคุมข้อมูลอื่นเมื่อเป็นไปได้ทางเทคนิค
			</p>

			<h3>6. คุณสามารถใช้สิทธิ์ของคุณได้อย่างไร?</h3>

			<p>
				คุณสามารถใช้สิทธิ์ของข้อมูลส่วนบุคคลของคุณได้ทุกเวลโดยส่งอีเมลไปที่: {supportLink} หรือที่อยู่ไปรษณีย์: 
				Av. Cerdanyola, 75 - 1º, CP 08172, Sant Cugat del Vallés, Barcelona, Spain. ในทั้งสองกรณี, คุณต้องระบุชื่อและนามสกุลของคุณ, 
				เช่นเดียวกับสำเนาของ DNI หรือบัตรประชาชนของคุณถ้าจำเป็น.<br>
				นอกจากนี้, หากคุณคิดว่ามีปัญหาเกี่ยวกับวิธีที่ Remove Background จัดการข้อมูลของคุณ, คุณสามารถยื่นเรื่องร้องเรียน 
				กับ <a href="{knowYourRightsLink}">หน่วยงานคุ้มครองข้อมูล</a> ที่เกี่ยวข้อง, ซึ่ง <a href="{aepdLink}">สำนักงานคุ้มครองข้อมูลแห่งสเปน</a> 
				เป็นหน่วยงานที่ระบุในกรณีของสเปน
			</p>

			<h3>7. มีการนำมาตรการรักษาความปลอดภัยมาใช้หรือไม่?</h3>
			<p>
				บริการใช้อมาตรการทางเทคนิคและองค์กรที่จำเป็นทั้งหมดเพื่อปกป้องความปลอดภัยและความสมบูรณ์ของข้อมูลส่วนบุคคลและไม่ใช่ส่วนบุคคลที่เก็บรวบรวม. 
				ทั้งต่อต้านการเข้าถึงที่ไม่ได้รับอนุญาตและการเปลี่ยนแปลงโดยไม่ได้ตั้งใจ, การสูญหายหรือการทำลาย.<br>
				ในกรณีใด ๆ, บริการไม่สามารถรับประกันความปลอดภัยสมบูรณ์ของข้อมูลที่เก็บรวบรวม, 
				ดังนั้นคุณต้องร่วมมือและใช้ความระมัดระวังเกี่ยวกับข้อมูลที่แชร์ตลอดเวลา.<br>
				คุณเข้าใจและยอมรับว่า, แม้หลังจากการลบ, ข้อมูลส่วนบุคคลและไม่ใช่ส่วนบุคคลอาจยังคงสามารถดูได้ในแคชหรือ 
				หากมีการคัดลอกหรือเก็บโดยผู้ใช้อื่น ๆ
			</p>

			<h3>8. มีการถ่ายโอนข้อมูลส่วนบุคคลหรือการถ่ายโอนระหว่างประเทศหรือไม่?</h3>

			<p>
				เราไม่ถ่ายโอนข้อมูลหรือการถ่ายโอนระหว่างประเทศ. อย่างไรก็ตาม, มีบุคคลที่สามที่จัดการส่วนหนึ่งของบริการ 
				ที่เราต้องการให้ปฏิบัติตามนโยบายความเป็นส่วนตัวของเราตามที่บังคับใช้กับพวกเขาและที่พวกเขามีนโยบายของตนเอง 
				บุคคลที่สามเหล่านี้เป็นผู้ให้บริการที่ดำเนินการในนามของเรา, เช่น การโฮสต์เว็บ, 
				การติดตามการวิเคราะห์, หรือการพัฒนาเว็บ.<br>
				นอกจากนี้, หากเราเชื่อว่ามันจำเป็นอย่างสมเหตุสมผลในการตอบสนองความต้องการทางกฎหมายใด ๆ, กระบวนการทางกฎหมาย 
				หรือผลประโยชน์ที่ถูกต้อง. ในกรณีใด ๆ, เราจะให้ข้อมูลที่จำเป็นอย่างเคร่งครัดเท่านั้น
			</p>

		`
	},
	cookiesPolicy: {
		lastUpdate: 'อัปเดตล่าสุด: 21 มิถุนายน 2024',
		content: `
			<h3>สรุป</h3>
			<ul>
			    <li>คุกกี้ที่ใช้: <strong>คุกกี้ของเราเองและของบุคคลที่สาม</strong></li>
			    <li>พวกเขาใช้เพื่อรับสถิติหรือไม่? <strong>ใช่, โดยมีพื้นฐานจากความสนใจที่ถูกต้องของเราในการจัดการบริการได้ดีขึ้น</strong></li>
			    <li>บริการของบุคคลที่สามที่ติดตั้งคุกกี้ผ่านเว็บไซต์นี้: <strong>Google, Google Analytics, Cloudflare, และ Stripe</strong></li>
			</ul>

			<h3>วิธีการกำหนดค่าและปิดการใช้งานคุกกี้</h3>
			<p>
			    คุณสามารถอนุญาต, บล็อก หรือ ลบคุกกี้ที่ติดตั้งในอุปกรณ์ของคุณจากเว็บเบราว์เซอร์ของคุณ. หากคุณไม่อนุญาตให้ติดตั้งคุกกี้ในอุปกรณ์ของคุณ, 
			    ประสบการณ์การท่องเว็บอาจแย่ลง. ด้านล่าง, คุณสามารถค้นหาวิธีการกำหนดค่าคุกกี้ในแต่ละเบราว์เซอร์:
			</p>
			<ul>
			    <li><a href="{externalLink: edgeCookies}">Edge</a></li>
			    <li><a href="{externalLink: chromeCookies}">Google Chrome</a></li>
			    <li><a href="{externalLink: googleAndroidCookies}">Google Android</a></li>
			    <li><a href="{externalLink: internetExplorer8Cookies}">Internet Explorer 8</a></li>
			    <li><a href="{externalLink: internetExplorer9Cookies}">Internet Explorer 9</a></li>
			    <li><a href="{externalLink: internetExplorer11Cookies}">Internet Explorer 11</a></li>
			    <li><a href="{externalLink: firefoxCookies}">Mozilla Firefox</a></li>
			    <li><a href="{externalLink: operaCookies}">Opera</a></li>
			    <li><a href="{externalLink: safariCookies}">Safari</a></li>
			    <li><a href="{externalLink: safariMobileCookies}">Safari Mobile</a></li>
			 </ul>

			<h3>1. ประเภทและการใช้งาน</h3>
			<p>บริการใช้คุกกี้ของเราเองและของบุคคลที่สามเพื่อปรับปรุงการท่องเว็บ, ให้บริการ และรับสถิติการใช้เว็บไซต์</p>

			<h3>2. คุกกี้คืออะไรและใช้ทำอะไร?</h3>
			<p>
			    คุกกี้คือไฟล์ข้อความที่ถูกส่งไปยังเว็บเบราว์เซอร์ของคอมพิวเตอร์, มือถือ หรือแท็บเล็ตของคุณและใช้ในการเก็บและเรียกคืนข้อมูลเกี่ยวกับ
			    การท่องเว็บที่ทำ. ตัวอย่างเช่น, เพื่อจดจำชื่อผู้ใช้และรหัสผ่านของคุณหรือการตั้งค่าโปรไฟล์ของคุณ
			</p>

			<h3>3. คุกกี้มีกี่ประเภท?</h3>
			<p>ตามผู้ที่จัดการพวกเขา:</p>
			<ul>
			    <li>คุกกี้ของเราเอง; พวกเขาถูกส่งไปยังเบราว์เซอร์ของคุณจากอุปกรณ์หรือโดเมนเว็บของเราเอง</li>
			    <li>คุกกี้ของบุคคลที่สาม; พวกเขาถูกส่งไปยังเบราว์เซอร์ของคุณจากอุปกรณ์หรือโดเมนเว็บที่เราไม่ได้จัดการโดยตรง, แต่โดยบุคคลที่สามเช่น Google</li>
			</ul>
			<p>ตามระยะเวลาที่พวกเขายังคงใช้งาน:</p>
			<ul>
			    <li>คุกกี้เซสชัน; พวกเขาอยู่ในไฟล์คุกกี้ของเบราว์เซอร์ของคุณจนกว่าคุณจะออกจากเว็บไซต์, ดังนั้นไม่มีคุกกี้ใด ๆ ที่ยังคงอยู่ในอุปกรณ์ของคุณ</li>
			    <li>คุกกี้ถาวร; พวกเขายังคงอยู่ในอุปกรณ์ของคุณและเว็บไซต์ของเราจะอ่านพวกเขาทุกครั้งที่คุณทำการเยี่ยมชมใหม่. คุกกี้เหล่านี้จะหยุดทำงานหลังจากวันที่ที่กำหนด</li>
			</ul>
			<p>สุดท้าย, ตามวัตถุประสงค์, เรามี:</p>
			<ul>
			    <li>คุกกี้ทางเทคนิค; พวกเขาปรับปรุงการท่องเว็บและการทำงานที่ถูกต้องของเว็บไซต์</li>
			    <li>คุกกี้การปรับเปลี่ยนส่วนบุคคล; พวกเขาอนุญาตการเข้าถึงบริการด้วยคุณสมบัติที่กำหนดล่วงหน้าตามชุดของเกณฑ์</li>
			    <li>คุกกี้วิเคราะห์; พวกเขาอนุญาตให้วัดและวิเคราะห์ทางสถิติการใช้บริการที่ให้</li>
			</ul>
			<p>รายการของคุกกี้ของบุคคลที่สามที่ใช้โดย <strong>remove-background.com</strong></p>
			<ul>
			    <li>
			        <a href="{externalLink: googleCookiesPolicy}">Google</a>: คุกกี้ของพวกเขา (NID หรือ CONSENT) อนุญาตให้ปรับแต่งวิธีการแสดงโฆษณานอก Google หรือเก็บข้อมูล
			        เช่น ภาษาที่ต้องการเมื่อแสดงผลการค้นหา.<br><a href="{externalLink: googleCookieTypes}">ข้อมูลเพิ่มเติม</a> เกี่ยวกับประเภทของคุกกี้ที่ Google ใช้ในบริการต่าง ๆ ของพวกเขา
			    </li>
			    <li>
			        <a href="{externalLink: googleAnalyticsCookies}">Google Analytics</a>: คุกกี้ของพวกเขา (เช่น _ga) อนุญาตให้นับจำนวนครั้งที่ผู้ใช้เยี่ยมชมเว็บไซต์, วิธีการ, เวลา, และจากที่ไหน.<br>
			        ในกรณีใด ๆ, คุณสามารถปิดการใช้งานคุกกี้ Google Analytics จาก <a href="{externalLink: disableGoogleAnalytics}">ที่นี่</a>
			    </li>
			    <li>Cloudflare: หากต้องการทราบนโยบายคุกกี้และการใช้งานของ Cloudflare, คลิก <a href="{externalLink: cloudflareCookiesPolicy}">ลิงก์นี้</a></li>
			    <li>Stripe: ค้นหาข้อมูล <a href="{externalLink: stripeCookiesPolicy}">ที่นี่</a> เกี่ยวกับนโยบายคุกกี้และการใช้งานของ Stripe</li>
			</ul>
		`
	}
};
